module.exports = __webpack_public_path__ + "static/img/equip-3.e399baae.png";